import { navLayoutDimensionsSlice } from './reducer';
const {
  rootNavComponentDimension,
  externalNavComponentDimension
} = navLayoutDimensionsSlice.actions;
export function getRootNavComponentDimensionAction(payload) {
  return rootNavComponentDimension(payload);
}
export function getExternalNavComponentDimensionAction(payload) {
  return externalNavComponentDimension(payload);
}